export default {
  custom_option: 'Anpassen',
  zero_option: 'Kein Trinkgeld',
};
